import type {FC, PropsWithChildren} from 'react';

import {cn} from '@/modules/foundation/shared/tailwind';

interface Props extends PropsWithChildren {
	classNameOverride?: {
		figure?: string;
		figcaption?: string;
		credit?: string;
		caption?: string;
	};
	credit?: string;
	caption?: string;
}

export const Figure: FC<Props> = ({children, classNameOverride, credit, caption}) => {
	return (
		<figure className={cn(['relative', 'h-full', classNameOverride?.figure])}>
			{children}
			<figcaption
				className={cn([
					'flex',
					'flex-wrap',
					'justify-between',
					'gap-x-4',
					'gap-y-1',
					'bg-black/70',
					'text-white',
					'absolute',
					'bottom-0',
					'left-0',
					'right-0',
					'py-1',
					'px-2',
					classNameOverride?.figcaption,
				])}
			>
				{caption && <span className={cn([classNameOverride?.caption])}>{caption}</span>}
				{credit && <strong className={cn([classNameOverride?.credit])}>{credit}</strong>}
			</figcaption>
		</figure>
	);
};
